export interface MessageOptions {
  ids: string[];
  label: string;
}

export interface VehicleMappedMessage {
  id: string;
  label: string;
  labelKey: string;
}

export function transformOptionsByMessageIds(
  options: Record<string, MessageOptions>,
): Record<string, VehicleMappedMessage> {
  const result: Record<string, VehicleMappedMessage> = {};

  for (const [labelKey, details] of Object.entries(options)) {
    const { ids, ...rest } = details;

    for (const id of ids) {
      if (result[id]) {
        throw Error(`[transformOptionsByMessageIds] Duplicate id detected: ${id}`);
      }

      result[id] = {
        id,
        labelKey,
        ...rest,
      } as VehicleMappedMessage;
    }
  }

  return result;
}
